import axios from "axios";
import Vue from 'vue';
import { decode, encode } from 'js-base64';

var MyPlugin = {};
MyPlugin.install = function (Vue, options) {
  const request = {
    domain: "https://api.projemikro.com/",
    //  domain: "http://localhost:3003/",
    donem: function () { let date = new Date(); return date.getFullYear() },
    ayar: function () {
      if (localStorage.getItem('tfx')) {
        let tkn = JSON.parse(localStorage.getItem('tfx'))
        let toke = tkn.egz.split('wpk')
        let yas = toke[1].split('atc')
        let yas1 = yas[1].split('aNg')
        let donen = {
          tkn: tkn,
          genel: JSON.parse(localStorage.getItem('tfx')),
          firmaid: toke[0] / 8589,
          kid: yas[0] / 8848,
          ya: yas1[0],
          page: tkn.pgs
        }
        return donen
      }
    },
    get: function (url) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.domain + url)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    post(url, data) { // buradaki alt function ile url yi create edebilirsin
      let postObje = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { "Content-type": "application/json; charset=UTF-8" }
      }
      return new Promise((resolve, reject) => {
        axios
          .post(this.domain + url, data)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    put(url, data) { // buradaki alt function ile url yi create edebilirsin
      let postObje = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { "Content-type": "application/json; charset=UTF-8" }
      }
      return new Promise((resolve, reject) => {
        axios
          .post(this.domain + url, data)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    delete: function (url) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.domain + url)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    saatligoster(tarih) {
      const monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]

      const d = new Date(tarih);
      return d.getDate() + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    },
    gruplama: function (source, tables, tablesKod, node, nodeKod) { // cihazgrup
      return new Promise((resolve, reject) => {


        var treeData = [];
        var folders = {};
        var cnt = 0;
        source.forEach(function (obj) {
          if (obj[tables] in folders) {
            const children = treeData[folders[obj[tables]]].nodes.filter(d => d.text === obj[node])
            if (children.length == 0) treeData[folders[obj[tables]]].nodes.push({ value: obj[node], text: obj[nodeKod] });
          }
          else { folders[obj[tables]] = treeData.push({ text: obj[tables], value: obj[tablesKod], nodes: [{ value: obj[node], text: obj[nodeKod] }] }) - 1; }
          cnt++

        });
        if (source.length == cnt) {
          // console.log(folders)
          // console.log(treeData)
          resolve(treeData)
        }
      })


    },
  }
  var helper = {
    login(username, password) {
      var tfx = {}
      return new Promise(function (resolve, reject) {
        let data = { kadi: username, pass: password }
        request.post('servis/login/', data)
          .then(res => {
            console.log(res)
            if (res.status === 200) {
              let fkt = {
                f: encode(res.results[0].fad), k: encode(res.results[0].isim),
                t: encode(res.results[0].tip), s: encode(res.results[0].kisa),
                p: res.results[0].entegre,
                key: res.results[0].keyler
              }
              Object.assign(tfx, fkt)
              helper.token(res.results[0], username, password)
                .then(res => {
                  //console.log(res)

                  Object.assign(tfx, { egz: res.erhan, pgs: res.page, songucelleme: Date.now() })
                  // this.mesaj = tfx
                  setTimeout(() => {
                    localStorage.setItem('tfx', JSON.stringify(tfx))
                    resolve({ data: res.data, status: true })
                  }, 500);
                })

            }
            else { resolve(false) }
          })
          .catch(err => reject(err.message))
      });
    },
    token(arr, username, pass) {
      let erhan = null;
      let sayfa = [];
      return new Promise((resolve) => {
        request.get('servis/sayfalistesi/' + arr.kid)
          .then(res => {
            res.results.forEach(element => {
              sayfa.push(parseInt(element.kodu))
            });
            resolve(
              {
                erhan: arr.firma * 8589 + 'wpk' + arr.kid * 8848 + 'atc' + arr.kodu + 'aNg' + encode(username) + 'btc' + encode(pass),
                page: sayfa,
              }
            )
          })

      })
    },

    logout() {
      localStorage.removeItem('tfx');
      localStorage.removeItem('vuex');

      setTimeout(() => { location.reload(true); }, 1000);
    },

    handleResponse(username, password) { // buradaki handleResponse main de helper yerine direkt bu isimle sÃ¼slÃ¼ parantezler iÃ§inde Ã§ekebilirmiyiz bir bakalÄ±m
      return new Promise(function (resolve, reject) {
        let data = { kadi: username, pass: password }
        request.post('login/', data)
          .then(res => {
            if (res.status === 200) { resolve(true) }
            else { reject(false) }
          })
          .catch(err => reject(err.message))
      });
    },
    ilkharfBuyuk(str) {
      if (str) {
        return str = str.replace(/([\wöçşğüıİ])/gi,
          function (a, b) { return b.replace("I", "ı").toLowerCase() }).replace(/(^[a-zöçşğüı]|[\s|\.][a-zöçşğüı])/g,
            function (c, d) {
              return d.replace("i", "i").toUpperCase();
            });
      }
      else {
        return "Tanımsız"
      }
    },
    tabloarama() {
      var e, t, n, a, l;
      for (e = document.getElementById("arama").value.toUpperCase(), t = document.getElementById("tablo").getElementsByTagName("tr"), l = 1; l < t.length; l++) {
        t[l].style.display = "none", n = t[l].getElementsByTagName("td");
        for (var m = 0; m < n.length; m++)
          if ((a = t[l].getElementsByTagName("td")[m]) && a.innerHTML.toUpperCase().indexOf(e) > -1) {
            t[l].style.display = "";
            break
          }
      }
    },
    groupByAdet(array, key) {
      return array.reduce((acc, item) => {
        const accAmout = acc[item[key]] || 0;
        return Object.assign(
          {}, acc, {
          [item[key]]: accAmout + 1,
        }
        )
      }
        , {})
    },
    groupByAdet2(arr) {
      arr.forEach(function (a) {
        if (!this[a.st]) {
          this[a.st] = { name: a.st, shape: a.ay, adet: 0 };
          result.push(this[a.st]);
        }
        this[a.st].adet += +1;
        //   this[a.color].instances += a.instances;
      }, Object.create(null));
    },
    //https://stackoverflow.com/questions/60474369/how-to-count-and-group-multiple-properties-values-in-array-of-objects
    //https://stackoverflow.com/questions/51040651/group-by-and-calculate-mean-average-of-properties-in-a-javascript-array  
    //https://stackoverflow.com/questions/51971373/group-by-count-distinct-sum-totals-from-objects-in-javascript-array   
    group2adet(arr, param2, param1) {
      //let deneme = []
      var result = arr.reduce(function (acc, obj) {
        let deneme = {}
        var g1 = acc[obj[param1]] = acc[obj[param1]] || {};
        var g2 = g1[obj[param2]] = g1[obj[param2]] || { count: 0 };
        g2.count++;
        //let deneme = {data:[g2.count++]}
        return acc;
      }, Object.create(null));
      return result;
    },
    trtgoster(uzuntarih) {
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      const d = new Date(uzuntarih);
      return d.getDate() + '-' + monthNames[d.getMonth()] + '-' + d.getFullYear();
    },
    trsaatyazdir() {
      let d = new Date();
      return d.getHours() + ':' + d.getMinutes()
    },
    piechart(array, keys) {
      let serie = new Array;
      let label = new Array;
      Object.keys(array).forEach(function (key) {
        serie.push(array[key])
        label.push(key)
      })
      return {
        series: serie,
        chartOptions: {
          chart: {
            type: 'pie',
            foreColor: '#a5a7ab',
          },
          labels: label,
          colors: ['#723ac3', "#864DD9", "#9762e6", "#a678eb"],
        }
      }
    },
    gunhesapla(t1) {
      var MS_one_day = 1000 * 60 * 60 * 24;
      var y = new Date();
      var x = new Date(t1);
      var date1 = Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()); //x
      var date2 = Date.UTC(y.getFullYear(), y.getMonth(), y.getDate()); //y
      return Math.floor((date2 - date1) / MS_one_day);
    },
    getNow() {
      const today = new Date();
      const date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      //const dateTime = date +' '+ time;
      return {
        tarih: date,
        saat: time
      }
    },
    sayfayetki: function (indexi) {
      if (localStorage.getItem('tfx')) {
        let obje = request.ayar().page
        let index = obje.indexOf(indexi);
        if (index > -1) {
          return true
        }
        else return false
      }
    }
  }
  Vue.prototype.$request = request;
  Vue.prototype.$helper = helper;
  //Vue.prototype.$servis = servis;
  // Vue.prototype.$sabit = sabit;
}
Vue.use(MyPlugin)
export default MyPlugin;



// WEBPACK FOOTER //
// ./src/helper.js